import React from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';


const ControllerLoupe = ({ breakpoint, smallInterval, intervalMarkers, barCenter }) => {
  if (intervalMarkers.length === 0) {
    return null;
  }

  const formatLoupeLabel = (date) => {
    const formats = {
      day: "MMM d'<br />'yyyy", // eslint-disable-line quotes
      month: breakpoint.greaterThanOrEqual.lg ? "MMMM'<br />'yyyy" : "MMM'<br />'yyyy", // eslint-disable-line quotes
      year: 'yyyy',
    };
    return format(date, formats[smallInterval.scale]);
  };

  const closest = intervalMarkers.reduce((prev, cur) => {
    return (Math.abs(cur.left - barCenter) < Math.abs(prev.left - barCenter) ? cur : prev);
  });
  const dateStr = formatLoupeLabel(closest.date);

  return (
    <div className="timeline-controller-loupe">
      <h4 key={barCenter} dangerouslySetInnerHTML={{ __html: dateStr }} />
    </div>
  );
};

ControllerLoupe.propTypes = {
  breakpoint: PropTypes.object,
  smallInterval: PropTypes.object,
  intervalMarkers: PropTypes.arrayOf(PropTypes.object),
  barCenter: PropTypes.number,
};

ControllerLoupe.defaultProps = {
  intervalMarkers: [],
};

export default ControllerLoupe;



// WEBPACK FOOTER //
// ./src/components/Timeline/ControllerLoupe.js